import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  AdminAuth: false,
  jwt_token: "",
  userId: null,
  username: null,
};
export const AdminAuthSlice = createSlice({
  name: "userAuth",
  initialState,
  reducers: {
    updateAuth: (state, action) => {
      state.AdminAuth = action.payload.AdminAuth;
      state.jwt_token = action.payload.jwt_token;
      state.userId = action.payload.userId;
      state.username = action.payload.username;
    },
  },
});

export const { updateAuth } = AdminAuthSlice.actions;
export default AdminAuthSlice.reducer;
